import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./assets/animated.css";
import "./assets/style.css";
import { initSentry } from "./lib/sentry/initSentry";
import { captureLandingExperiment } from "./lib/analytics/landingExperiment";
import { initializeUTMTracking } from "./lib/analytics/utmTracking";
import { quietConsoleInProduction } from "./lib/utils/quietConsole";

// Before Sentry, so console breadcrumbs still get collected. See the util.
quietConsoleInProduction();

initSentry();

// Initialize UTM tracking on app load
initializeUTMTracking();
captureLandingExperiment();

// Prevent macOS trackpad pinch-to-zoom from zooming the whole page.
// Trackpad pinch fires wheel events with ctrlKey=true; Safari also fires
// gesturestart/gesturechange. Block both globally so only in-canvas zoom works.
document.addEventListener(
  "wheel",
  (e) => {
    if (e.ctrlKey || e.metaKey) e.preventDefault();
  },
  { passive: false }
);
document.addEventListener("gesturestart", (e) => e.preventDefault(), {
  passive: false,
});
document.addEventListener("gesturechange", (e) => e.preventDefault(), {
  passive: false,
});

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  // <React.StrictMode>
  <App />
  //</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
